import { useScroll } from '../../hooks/useScroll'

export interface ScrollToTopProps {
  container?: HTMLElement | Window | null
  threshold?: number
}

export default function ScrollToTop({
  container = document.getElementById('root'),
  threshold = 300,
}: ScrollToTopProps) {
  const { isVisible, scrollToTop } = useScroll({ container, threshold })

  if (!isVisible) return null

  return (
    <button
      onClick={scrollToTop}
      className="sc-mv-scroll-top fixed bottom-[36px] w-[50px] h-[50px] right-2 md:right-8 flex items-center justify-center tc-mv-blur text-white rounded-full shadow-lg transition-colors duration-200 focus:outline-none"
      aria-label="Scroll to top"
      type="button"
      data-testid="scroll-to-top-button"
    >
      <i className="fa-solid fa-arrow-up text-lg" />
    </button>
  )
}
